import React, { Component } from "react";
import {
    Button,
    CardBody,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import * as BB from "../../../components/BBComponent";
import * as loadingActions from "../../../redux/actions/loadingActions";
import { bindActionCreators } from "redux";
import notify from "devextreme/ui/notify";
import { CustomCard } from "../../../components/custom";

import { post } from "axios";
import ReactHtmlParser from "react-html-parser";
import { callAPI, callApiGet } from "../../../components/Axios";
import { t } from "i18next";

let answers = [];

class Surveys extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: true,
            fadeIn: true,
            timeout: 50,
            talepEden: "",
            firma: "",
            departman: "",
            gorev: "",
            kategori: "",
            aciklama: "",
            aciliyet: "",
            etki: "",
            gridData: [],
            editRowVisible: false,
            QuestionsAll: [],
            selectedTaskSurveyID: "",
            selectedTaskID: "",
            selectedTaskDescription: "",
            surveyRowLenght: 0,
            showDetail: true,
            selectedSurveyReply: [],
            isLoadingSurveyDetail: false,
            isAnswer: false,
            isMobile: window.innerWidth <= 768,
            ratingAnswers: {} // Rating sistemi için
        };

        this.changeSelectionPriority = this.changeSelectionPriority.bind(this);
        this.answer = this.answer.bind(this);
        this.gridRef = React.createRef();

        let { t } = this.props;

        // this.languages = {
        //   toplamTalepSayısı:t('toplamTalepSayısı')

        // }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    handleResize = () => {
        this.setState({
            isMobile: window.innerWidth <= 768
        });
    }


    componentDidMount() {
        this.getData();
    }

    getData() {
        //this.props.actions.isLoading(true);

        callAPI(
            callApiGet,
            "api/TaskSurvey/GetAllSurveys",
            {},
            (res) => {
                console.log("data", res);
                const data = res.data;
                this.setState({ gridData: data, selectedTaskID: data.TaskNumber });
            },
            true
        );
        // this.props.actions.isLoading(false);
    }

    getTaskID(TaskNumber) {
        BB.FetchJSON(
            "api/TaskDetail/GetTaskIDBYTaskNumber?TaskNumber=" + TaskNumber
        ).then((data) => {
            this.getTaskData(data.data);
        });
    }

    getTaskData(ID) {




        // BB.FetchJSON("api/TaskDetail/GetGridData?ID=" + ID).then((data) => {
        //   this.setState({ selectedTaskDescription: data.Description });
        // });


        let url = "api/TaskDetail/GetGridData?ID=" + ID;
        callAPI(
            callApiGet,
            url,
            {},
            async (res) => {
                this.setState({ selectedTaskDescription: res.data.Description });

            }
            ,
            true
        );

    }

    delete(ID) {
        this.props.actions.isLoading(true);
        BB.FetchJSON("api/TaskSurvey/Delete?ID=" + ID).then((data) => {
            if (data.MessageStatus === true) {
                this.setState({
                    editRowVisible: false,
                    editPoolVisible: false,
                    selectedName: "",
                });
                this.getData();
                this.props.actions.isLoading(false);
                notify("Anket Yoksayıldı!", "success", 1000);
            } else {
                this.setState({
                    editRowVisible: false,
                    editPoolVisible: false,
                    selectedName: "",
                });
                notify("Anket Silme Hata!", "warning", 2000);
                this.props.actions.isLoading(false);
            }
        });
    }

    answer(ID) {
        // this.props.actions.isLoading(true);
        //  callAPI(
        //   callApiGet,
        //   "api/TaskSurvey/TaskAnswer?ID=" + ID,
        //   {},
        //   async (res) => {
        //     const data = res.data;
        //     var questions = [];

        //     for (var i = 0; i < data.Survey.SurveyQuestion.length; i++) {
        //       answers.push({
        //         q: i,
        //         a: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option,
        //       });
        //       questions.push({
        //         Question: data.Survey.SurveyQuestion[i].Question,
        //         Answer1: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option,
        //         Answer2: data.Survey.SurveyQuestion[i].SurveyQuestionOption[1].Option,
        //         Answer3: data.Survey.SurveyQuestion[i].SurveyQuestionOption[2].Option,
        //         Answer4: data.Survey.SurveyQuestion[i].SurveyQuestionOption[3].Option,
        //       });
        //     }
        //     this.setState({ QuestionsAll: questions });
        //     this.getTaskID(this.state.selectedTaskID.toString());    },
        //   true
        // );





        let url = "api/TaskSurvey/TaskAnswer?ID=" + ID;
        callAPI(
            callApiGet,
            url,
            {},
            async (res) => {
                if (res?.data) {
                    if (!res || !res.data || res.data.length < 1) return;

                    var questions = [];
                    for (var i = 0; i < res.data.Survey.SurveyQuestion.length; i++) {
                        const question = res.data.Survey.SurveyQuestion[i];

                        if (question.QuestionType === "text") {
                            // Text tipi soru
                            questions.push({
                                Question: question.Question,
                                QuestionType: "text",
                                QuestionID: question.ID,
                                Placeholder: question.Placeholder || "Lütfen cevabınızı buraya yazın...",
                                Answer1: "",
                                Answer2: "",
                                Answer3: "",
                                Answer4: "",
                            });
                        } else {
                            // Choice tipi soru (varsayılan)
                            questions.push({
                                Question: question.Question,
                                QuestionType: "choice",
                                QuestionID: question.ID,
                                Answer1: question.SurveyQuestionOption[0]?.Option,
                                Answer2: question.SurveyQuestionOption[1]?.Option,
                                Answer3: question.SurveyQuestionOption[2]?.Option,
                                Answer4: question.SurveyQuestionOption[3]?.Option,
                                OptionID1: question.SurveyQuestionOption[0]?.ID,
                                OptionID2: question.SurveyQuestionOption[1]?.ID,
                                OptionID3: question.SurveyQuestionOption[2]?.ID,
                                OptionID4: question.SurveyQuestionOption[3]?.ID,
                            });
                        }
                    }
                    this.setState({ QuestionsAll: questions });
                    if (res.data.Survey.TaskSurveyReply.length > 0) {
                        for (let i = 0; i < res.data.Survey.TaskSurveyReply.length; i++) {
                            answers.push({
                                q: i,
                                a: res.data.Survey.TaskSurveyReply[i].Reply,
                            });
                            this.setState({ selectedSurveyReply: res.data.Survey.TaskSurveyReply, isLoadingSurveyDetail: true });
                        }
                    }
                }
            },
            true
        );



        // BB.FetchJSON("api/TaskSurvey/TaskAnswer?ID=" + ID).then((data) => {


        //   var questions = [];

        //   for (var i = 0; i < data.Survey.SurveyQuestion.length; i++) {
        //     /*  answers.push({
        //             q: i,
        //             a: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option
        //          }); */
        //     questions.push({
        //       Question: data.Survey.SurveyQuestion[i].Question,
        //       Answer1: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option,
        //       Answer2: data.Survey.SurveyQuestion[i].SurveyQuestionOption[1].Option,
        //       Answer3: data.Survey.SurveyQuestion[i].SurveyQuestionOption[2].Option,
        //       Answer4: data.Survey.SurveyQuestion[i].SurveyQuestionOption[3].Option,
        //     });
        //   }
        //   this.setState({ QuestionsAll: questions });
        // });
    }





    // BB.FetchJSON("api/TaskSurvey/TaskAnswer?ID=" + ID).then((data) => {
    //   var questions = [];

    //   for (var i = 0; i < data.Survey.SurveyQuestion.length; i++) {
    //     answers.push({
    //       q: i,
    //       a: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option,
    //     });
    //     questions.push({
    //       Question: data.Survey.SurveyQuestion[i].Question,
    //       Answer1: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option,
    //       Answer2: data.Survey.SurveyQuestion[i].SurveyQuestionOption[1].Option,
    //       Answer3: data.Survey.SurveyQuestion[i].SurveyQuestionOption[2].Option,
    //       Answer4: data.Survey.SurveyQuestion[i].SurveyQuestionOption[3].Option,
    //     });
    //   }
    //   this.setState({ QuestionsAll: questions });
    //   this.getTaskID(this.state.selectedTaskID.toString());
    //  // this.props.actions.isLoading(false);
    // });



    // Eski sistem - artık kullanılmıyor
    changeSelectionPriority(e) {
        // Rating sistemi için kullanılmıyor
    }

    // Yıldız rating sistemi için yeni metod
    handleStarRating = (questionIndex, rating) => {
        const question = this.state.QuestionsAll[questionIndex];

        // Mevcut cevabı answers array'inden çıkar
        answers = answers.filter(item => item.q !== parseInt(questionIndex) || item.type !== "choice");

        // Yeni rating cevabı ekle
        if (rating) {
            answers.push({
                q: parseInt(questionIndex),
                a: rating,
                surveyQuestionId: question.QuestionID,
                surveyQuestionOptionId: null, // Yıldız sistemi için şık ID'si yok
                reply: rating,
                comment: null,
                type: "choice"
            });
        }

        // State'i güncelle
        const updatedRatingAnswers = { ...this.state.ratingAnswers };
        updatedRatingAnswers[questionIndex] = rating;
        this.setState({ ratingAnswers: updatedRatingAnswers });
    }

    handleTextChange = (e) => {
        const q = e.target.id.split('-')[0];
        const text = e.target.value;

        // Mevcut cevabı bul ve sadece comment kısmını güncelle
        const existingAnswer = answers.find(item => item.q == q);
        const question = this.state.QuestionsAll[q];

        if (existingAnswer) {
            existingAnswer.comment = text;

            // Text tipi sorular için reply'ı "text" olarak ayarla
            if (question.QuestionType === "text") {
                existingAnswer.reply = "text";
                existingAnswer.a = null;
                existingAnswer.surveyQuestionOptionId = null;
                existingAnswer.type = "text";
            }
        } else {
            // Text tipi sorular için yeni cevap oluştur
            if (question.QuestionType === "text") {
                answers.push({
                    q: parseInt(q),
                    a: null,
                    surveyQuestionId: question.QuestionID,
                    surveyQuestionOptionId: null,
                    reply: "text",
                    comment: text,
                    type: "text"
                });
            }
        }
    }


    onToolbarPreparing = (e) => {
        let ths = this;
        let toolbarItems = e.toolbarOptions.items;
        let totalRow = t("toplamTalepSayisi");
        //totalRow += ths.gridData.length;
        //Toplam Checkbox
        //  toolbarItems.unshift({
        //     location: 'before',
        //     template: 'pageName'
        //  });
        toolbarItems.unshift({
            location: "center",
            template: "totalGroupCount",
        });
        toolbarItems.unshift({
            location: "before",
            template: "pageName",
        });
    };

    toolbarItemRender = (e) => {
        const isMobile = window.innerWidth <= 768;
        return (
            isMobile ? (
                <div className="informer" style={{
                    width: '150px', height: '80px', textAlign: 'center', color: 'white', margin: '0px -120px 0px 155px', float: 'none'
                }}>
                    <span className="name" >{t("toplamAnketSayisi")} {":"} {this.state.gridData ? this.state.gridData.length : "0"}</span>
                </div>
            ) : (
                <div className="informer">
                    <h3 className="count" >
                        {this.state.gridData ? this.state.gridData.length : "0"}
                    </h3>
                    <span className="name" >{t("toplamAnketSayisi")}</span>
                </div>
            )
        );
    };
    pageNameRender = (e) => {
        return (
            <div className="informer">
                <h5 className="count" style={{ marginTop: 7, marginLeft: 10 }}>
                    <strong>{t("anketlerim")}</strong>
                </h5>
            </div>
        );
    };

    answerSave() {
        const formData = new FormData();
        let questionsAll = this.state.QuestionsAll;

        // Yıldız rating sistemi validasyonu
        for (let i = 0; i < questionsAll.length; i++) {
            const question = questionsAll[i];

            if (question.QuestionType === "choice") {
                // Choice tipi sorular için yıldız puanı kontrol et
                const questionAnswer = answers.find(a => a.q === i && a.type === "choice");

                if (!questionAnswer || !questionAnswer.a) {
                    notify(`"${question.Question}" sorusu için lütfen yıldız puanı veriniz.`, "warning", 4000);
                    return;
                }
            } else if (question.QuestionType === "text") {
                // Text tipi sorular için metin girişi zorunlu
                const textAnswer = answers.find(a => a.q === i && a.type === "text");
                if (!textAnswer || !textAnswer.comment || textAnswer.comment.trim() === "") {
                    notify(`"${question.Question}" sorusu için metin girişi yapmalısınız.`, "warning", 4000);
                    return;
                }
            }
        }

        formData.append("jsonText", JSON.stringify(answers));
        formData.append("TaskSurveyID", this.state.selectedTaskSurveyID);
        formData.append("TaskID", this.state.selectedTaskID);

        if (answers.length === 0) {
            notify("Anket cevapları boş geçilemez!", "warning", 4000);
            return;
        }

        post("api/TaskSurvey/TaskAnswer", formData, {
            headers: {
                "content-type": "multipart/form-data",
            },
        }).then((res) => {
            if (res.data.MessageStatus === true) {
                this.setState({
                    editRowVisible: false,
                    addRowVisible: false,
                    selectedName: "",
                    selectedMasterPoolID: null,
                });
                this.getData(this.state.selectedParentID);

                //this.props.actions.isLoading(false);
                notify("Anket Tamamlandı!", "success", 1000);
                answers = [];
            } else {
                this.setState({
                    editRowVisible: false,
                    addRowVisible: false,
                    selectedName: "",
                    selectedMasterPoolID: null,
                });
                notify("Anket Oluşturma Hata! : " + res.data.Message, "warning", 1000);
                // this.props.actions.isLoading(false);
            }
        });
    }

    actionButton = (cellData) => {
        console.log("cellData", cellData);
        //debugger
        return (
            <div>
                {/*{data.map((item, index) => (*/}
                {/*    <div key={index}>*/}
                {/*        {item.IsCompleted ?*/}
                {cellData.data.IsCompleted ?
                    <Button
                        style={{ marginLeft: 5 }}
                        color={"info"}
                        outline
                        onClick={() => {
                            this.setState(
                                {
                                    editRowVisible: true,
                                    selectedTaskSurveyID: cellData.data.ID,
                                    selectedTaskID: cellData.data.TaskNumber,
                                },
                                this.answer(cellData.data.ID)
                            );
                        }}
                    >
                        {t("duzenle")}
                    </Button>
                    :
                    <Button
                        style={{ marginLeft: 5 }}
                        color={"info"}
                        outline
                        onClick={() => {
                            this.setState(
                                {
                                    editRowVisible: true,
                                    selectedTaskSurveyID: cellData.data.ID,
                                    selectedTaskID: cellData.data.TaskNumber,
                                },
                                this.answer(cellData.data.ID)
                            );
                        }}
                    >
                        {t("cevapla")}
                    </Button>
                }
                {/*        </div>*/}
                {/*    ))*/}
                {/*}*/}
            </div>
        );
    };


    render() {
        return <Render ths={this} />;
    }
}

export const Render = (ths) => {
    const { t } = useTranslation();
    let state = ths.ths.state;
    const event = ths.ths;
    const { isMobile } = ths.ths.state;
    return (
        <>
            <Row>
                <Col xs="12" sm="12">
                    <CustomCard cardStyle="card-dashboard-calendar pb-0">
                        <CardBody>
                            {BB.DxDataGridForSurvey(
                                ths.ths.state.gridData,
                                event,
                                state.showDetail, isMobile
                            )}
                        </CardBody>
                    </CustomCard>
                </Col>
                <Modal
                    isOpen={state.editRowVisible}
                    centered={true}
                    size={isMobile ? "sm" : "md"}
                    style={{
                        maxWidth: isMobile ? "95vw" : "600px",
                        margin: isMobile ? "0.5rem" : "auto"
                    }}
                    className="survey-modal"
                >
                    <ModalHeader
                        toggle={() => event.setState({ editRowVisible: false })}
                        style={{
                            backgroundColor: "#f8f9fa",
                            borderBottom: "1px solid #dee2e6",
                            padding: isMobile ? "0.5rem 0.75rem" : "0.75rem 1rem"
                        }}
                    >
                        <div>
                            <h5 style={{
                                margin: 0,
                                color: "#495057",
                                fontWeight: "600",
                                fontSize: isMobile ? "0.9rem" : "1rem"
                            }}>
                                {`${state.selectedTaskID} numaralı talep anketi`}
                            </h5>
                            <div style={{ marginTop: "0.25rem", padding: "0.5rem", backgroundColor: "#e9ecef", borderRadius: "0.25rem" }}>
                                <h6 style={{ margin: 0, color: "#6c757d", fontSize: "0.7rem", fontWeight: "500" }}>
                                    {t("talepAciklamasi")}
                                </h6>
                                <p style={{
                                    fontWeight: "400",
                                    margin: "0.25rem 0 0 0",
                                    color: "#495057",
                                    lineHeight: "1.3",
                                    fontSize: "0.8rem"
                                }}>
                                    {ReactHtmlParser(state.selectedTaskDescription)}
                                </p>
                            </div>
                        </div>
                    </ModalHeader>

                    <ModalBody style={{
                        padding: isMobile ? "0.5rem" : "0.75rem",
                        maxHeight: isMobile ? "55vh" : "65vh",
                        overflowY: "auto",
                        backgroundColor: "#ffffff"
                    }}>
                        <div className="survey-list" style={{ padding: "0", width: "100%" }}>
                            {state.QuestionsAll.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: "100%",
                                            marginBottom: isMobile ? "1rem" : "1.25rem",
                                            padding: isMobile ? "0.75rem" : "1rem",
                                            border: "1px solid #e9ecef",
                                            borderRadius: "0.375rem",
                                            backgroundColor: "#fafafa",
                                            transition: "all 0.2s ease-in-out",
                                            boxSizing: "border-box"
                                        }}
                                    >
                                        <div style={{ marginBottom: "0.75rem" }}>
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    backgroundColor: "#007bff",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    width: "22px",
                                                    height: "22px",
                                                    textAlign: "center",
                                                    lineHeight: "22px",
                                                    fontSize: "0.875rem",
                                                    fontWeight: "600",
                                                    marginRight: "0.5rem"
                                                }}
                                            >
                                                {index + 1}
                                            </span>
                                            <span style={{
                                                fontSize: "0.9rem",
                                                fontWeight: "500",
                                                color: "#495057",
                                                lineHeight: "1.4"
                                            }}>
                                                {item.Question}
                                            </span>
                                        </div>

                                        {item.QuestionType === "choice" ? (
                                            <div>
                                                {/* Şıkları listele */}
                                                <div style={{
                                                    width: "100%",
                                                    marginBottom: "1rem",
                                                    padding: "0.75rem",
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: "0.25rem",
                                                    border: "1px solid #dee2e6",
                                                    boxSizing: "border-box"
                                                }}>
                                                    <div style={{ fontSize: "0.8rem", marginBottom: "0.25rem", color: "#6c757d" }}>
                                                        <strong>Seçenekler:</strong>
                                                    </div>
                                                    <div style={{ fontSize: "0.8rem", marginBottom: "0.25rem", color: "#495057" }}>
                                                        • {item.Answer1}
                                                    </div>
                                                    <div style={{ fontSize: "0.8rem", marginBottom: "0.25rem", color: "#495057" }}>
                                                        • {item.Answer2}
                                                    </div>
                                                    <div style={{ fontSize: "0.8rem", marginBottom: "0.25rem", color: "#495057" }}>
                                                        • {item.Answer3}
                                                    </div>
                                                    <div style={{ fontSize: "0.8rem", marginBottom: "0", color: "#495057" }}>
                                                        • {item.Answer4}
                                                    </div>
                                                </div>

                                                {/* Yıldız rating sistemi */}
                                                <div style={{
                                                    width: "100%",
                                                    textAlign: "center",
                                                    padding: "0.75rem",
                                                    backgroundColor: "#ffffff",
                                                    borderRadius: "0.25rem",
                                                    border: "1px solid #dee2e6",
                                                    boxSizing: "border-box"
                                                }}>
                                                    <div style={{
                                                        marginBottom: "0.75rem",
                                                        fontSize: "0.8rem",
                                                        fontWeight: "500",
                                                        color: "#495057"
                                                    }}>
                                                        Bu soruya vereceğiniz puan:
                                                    </div>
                                                    <div className="star-rating" style={{ marginBottom: "0.5rem" }}>
                                                        {[1, 2, 3, 4, 5].map((star) => (
                                                            <span
                                                                key={star}
                                                                style={{
                                                                    fontSize: isMobile ? "22px" : "26px",
                                                                    color: (event.state.ratingAnswers && event.state.ratingAnswers[index] >= star) ? "#FFD700" : "#DDD",
                                                                    cursor: "pointer",
                                                                    marginRight: isMobile ? "5px" : "7px",
                                                                    transition: "color 0.2s ease-in-out",
                                                                    textShadow: "0 1px 2px rgba(0,0,0,0.1)"
                                                                }}
                                                                onClick={() => event.handleStarRating(index, star)}
                                                                onMouseEnter={(e) => {
                                                                    if (!event.state.ratingAnswers || event.state.ratingAnswers[index] < star) {
                                                                        e.target.style.color = "#FFA500";
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (!event.state.ratingAnswers || event.state.ratingAnswers[index] < star) {
                                                                        e.target.style.color = "#DDD";
                                                                    }
                                                                }}
                                                            >
                                                                ★
                                                            </span>
                                                        ))}
                                                    </div>
                                                    <div style={{
                                                        fontSize: "0.8rem",
                                                        color: "#6c757d",
                                                        fontWeight: "500"
                                                    }}>
                                                        {event.state.ratingAnswers && event.state.ratingAnswers[index] ?
                                                            `Puanınız: ${event.state.ratingAnswers[index]}/5` :
                                                            "Lütfen puan veriniz"}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            // Text tipi sorular - serbest metin alanı
                                            <div style={{ width: "100%" }}>
                                                <textarea
                                                    id={`${index}-comment`}
                                                    className="form-control"
                                                    rows="3"
                                                    placeholder={item.Placeholder || t("lütfen cevabınızı buraya yazın")}
                                                    value=""
                                                    onChange={event.handleTextChange}
                                                    style={{
                                                        width: "100%",
                                                        fontSize: "0.8rem",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: "0.25rem",
                                                        resize: "none",
                                                        padding: "0.5rem",
                                                        backgroundColor: "#ffffff",
                                                        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                                                        boxSizing: "border-box"
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = "#007bff";
                                                        e.target.style.boxShadow = "0 0 0 0.2rem rgba(0,123,255,0.25)";
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = "#ced4da";
                                                        e.target.style.boxShadow = "none";
                                                    }}
                                                ></textarea>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </ModalBody>
                    <ModalFooter style={{
                        backgroundColor: "#f8f9fa",
                        borderTop: "1px solid #dee2e6",
                        padding: isMobile ? "0.5rem 0.75rem" : "0.75rem 1rem",
                        justifyContent: "flex-end"
                    }}>
                        <Button
                            onClick={() => event.setState({ editRowVisible: false })}
                            color="secondary"
                            outline
                            size="sm"
                            style={{
                                marginRight: "0.5rem",
                                padding: "0.375rem 1rem",
                                fontWeight: "500",
                                fontSize: "0.875rem"
                            }}
                        >
                            {t("iptal")}
                        </Button>
                        <Button
                            onClick={() => event.answerSave()}
                            color="primary"
                            size="sm"
                            style={{
                                padding: "0.375rem 1rem",
                                fontWeight: "500",
                                fontSize: "0.875rem",
                                boxShadow: "0 2px 4px rgba(0,123,255,0.2)"
                            }}
                        >
                            {t("kaydet")}
                        </Button>
                    </ModalFooter>
                </Modal>
            </Row>
        </>
    );
};

function mapStateToProps(state) {
    return {
        ownsurveys: state.surveyReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            isLoading: bindActionCreators(loadingActions.setLoading, dispatch),
        },
    };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Surveys));

